import { Card } from "$root/components/EvolvedPrint/components/Card";
import type { PrintableProps } from "$root/components/EvolvedPrint/configuration/types";
import type { ReportTemplateItemMap } from "$root/functional-areas/reports/report-latest";

export function FreeText(
	props: PrintableProps<{ config: ReportTemplateItemMap["freeText"] }, unknown>,
): React.JSX.Element {
	return <Card>{props.config.content}</Card>;
}
